import { defineComponent as _defineComponent } from 'vue'
import { Personalisation } from 'ctp-personalisation-search';
import { computed, PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RawData',
  props: {
  perso: {
    type: Object as PropType<Personalisation>,
    default: () => ({})
  }
},
  setup(__props) {

const props = __props;



const displayPayload = computed(() => {
  if (props.perso.rawData) {
    const json = JSON.parse(props.perso.rawData);
    return JSON.stringify(json, undefined, 4);
  }
  return '';
});


return { __sfc: true,props, displayPayload }
}

})